import {
  Box, Typography
} from '@mui/material';

// ─── Shared : sélecteur équipe ────────────────────────────────────
function TeamSelector({ teams, selectedType, onSelect }) {
  return (
    <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
      {teams.map((team) => (
        <Box key={team.type} onClick={() => onSelect(team.type)} sx={{
          flex: '1 1 auto', minWidth: 120, p: '10px 14px',
          borderRadius: '10px', cursor: 'pointer',
          border: selectedType === team.type ? `2px solid ${team.color}` : '1.5px solid #e0e0e0',
          backgroundColor: selectedType === team.type ? team.bg : '#fff',
          transition: 'all 0.15s',
          '&:hover': { backgroundColor: team.bg, borderColor: team.color },
        }}>
          <Typography sx={{ fontSize: 13, fontWeight: 600, color: selectedType === team.type ? team.color : '#444' }}>
            {team.label}
          </Typography>
          <Typography sx={{ fontSize: 11, color: '#888' }}>{team.desc}</Typography>
        </Box>
      ))}
    </Box>
  );
}

export default TeamSelector;

